
$(document).ready(function(){
    
  // Build a Box small print

  setTimeout(function(){  

    $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").prop(":", "").fadeTo( "slow", 1 );

      
      $(".rt-r-gap-4.justify-evenly button.rt-BaseButton").html(function () {
          return $(this).html().replace(" $", "<span>$").replace(":", " "); 
      });

      $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
          return $(this).html().replace(":", " ").replace(/ \(.*\) \-/, " -").replace("$", "<span>$"); 
      });

    $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", " "); 
      });
  
      // $(".bb-details-col.themeRight .rt-Flex .rt-Box:nth-last-child(3)").after("<div class='bbsmallprint discountsmallprint'>Discount automatically applied at check out.</div> ");
      //$(".rt-ScrollAreaRoot").append("<div class='bbsmallprint'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");
  
      $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
      });

      $("span.rt-Text.rt-r-size-2.rt-r-weight-bold.rt-r-ta-center").html(function () { 
        return $(this).html().replace(/\(.*\)/, ""); 
      });



      $("span.rt-Text.rt-r-size-2.rt-r-weight-bold.rt-r-ta-center").text(function () { 
        return $(this).text().split(" - ").slice(0, 2).join(" - ");
      });
    
  }, 4000);
});

 var thisThing = document.getElementsByClassName("rt-Flex rt-r-fd-column rt-r-gap-2 bb-details__info")[0];
//var thisThing = document.getElementsByClassName("bb-details__info")[0];

console.log(thisThing);
const observer = new MutationObserver( list => {
  const evt = new CustomEvent('dom-changed', {detail: list});
  thisThing.dispatchEvent(evt)
});
observer.observe(thisThing, {attributes: true, childList: true, subtree: true});

thisThing.addEventListener('dom-changed', e => doThings(e));

function doThings(e) {
  console.log(e)
  
   setTimeout(function(){  
       
      $("span.rt-Text.rt-r-size-2.rt-r-weight-medium.bb-details__text-content--custom-color").html(function () {
        //const found = $(this).html().match(/^(\$\d+.\d{2})$/);
        var price = $(this).html().substring($(this).html().indexOf("$"));
        console.log(price);
        if(price.indexOf("span")> -1){
          console.log("in here");
          return; 
        } else {
          return $(this).html().replace(":", " ").replace(/ \(.*\) \-/, " -").replace("$", "<span>$"); 
        }
      });

      $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", " "); 
      });

      $("button.rt-reset.rt-BaseButton.rt-r-size-2.rt-variant-solid.rt-high-contrast.rt-Button.bb-btn.bb-btn__primary--custom-color").html(function () {
          return $(this).html().replace(":", " "); 
      });

      }, 100);
  
}
